var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "collapsible" },
    [
      _c(
        "header",
        {
          staticClass: "collapsible__header",
          attrs: { role: "heading" },
          on: { click: _vm.toggleIsExpanded }
        },
        [
          _c("h2", [_vm._v(_vm._s(_vm.heading))]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "collapsible__button",
              attrs: {
                type: "button",
                "aria-expanded": _vm.isExpanded,
                "aria-label": _vm.isExpanded ? "Collapse" : "Expand"
              }
            },
            [
              _c("span", {
                staticClass: "collapsible__icon",
                class: _vm.iconClass
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          on: {
            "before-enter": _vm.collapse,
            "before-leave": _vm.expand,
            enter: _vm.expand,
            leave: _vm.collapse
          }
        },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isExpanded,
                expression: "isExpanded"
              }
            ],
            staticClass: "collapsible__body",
            attrs: { role: "region", "aria-hidden": !_vm.isExpanded },
            domProps: { innerHTML: _vm._s(_vm.bodyHtml) }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }